import React from "react";
import {ChatContextType} from "../types/chat-context";
import {ChatContext} from "../context/chat-context";

export function useChatContext(): ChatContextType {
  return React.useContext(ChatContext)
}